import { render } from "./SitesServicesPage.vue?vue&type=template&id=db744f78&scoped=true"
import script from "./SitesServicesPage.vue?vue&type=script&lang=js"
export * from "./SitesServicesPage.vue?vue&type=script&lang=js"

import "./SitesServicesPage.vue?vue&type=style&index=0&id=db744f78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db744f78"]])

export default __exports__